<div class="shell">

  @if (mockMode()) {
    <div class="mock-banner">
      <wg-icon name="alert" [size]="13" />
      <strong>Mock mode</strong>
      <span>Data is local to this browser and will not persist beyond your session.</span>
    </div>
  }

  <header class="topbar">
    <!-- Brand -->
    <a routerLink="/create" class="brand">
      <img src="assets/WatchGuard_Logo_Black_Red.png" alt="WatchGuard" class="brand__logo wg-logo-img" />
      <span class="brand__product">Agent Hub Studio</span>
    </a>

    @if (shellContext.builder(); as builder) {
      <!-- Builder breadcrumb -->
      <div class="crumb">
        <a routerLink="/agents" class="btn btn-ghost btn-sm crumb__back">
          <wg-icon name="arrow-left" [size]="15" /> Agents
        </a>
        <span class="crumb__sep">/</span>
        @if (builder.color) {
          <span class="crumb__avatar" [style.background]="builder.color + '1c'" [style.color]="builder.color">
            {{ (builder.name || 'A').trim().charAt(0).toUpperCase() }}
          </span>
        }
        <span class="crumb__name">{{ builder.name || 'Untitled agent' }}</span>
        <app-status-pill [state]="builder.state" [isAdmin]="isAdmin()" />
        @switch (builder.saveState) {
          @case ('saving') {
            <span class="crumb__save"><span class="spinner crumb__spinner"></span> Saving…</span>
          }
          @case ('saved') {
            <span class="crumb__save"><wg-icon name="check" [size]="13" /> Saved</span>
          }
          @case ('error') {
            <span class="crumb__save crumb__save--error"><wg-icon name="alert" [size]="13" /> Save failed</span>
          }
        }
      </div>

      <div class="topbar__spacer"></div>

      <!-- Builder actions -->
      <div class="builder-actions">
        @if (builder.readiness; as readiness) {
          <app-readiness-pill [readiness]="readiness" (jump)="builder.onJumpSection?.($event)" />
        }
        @if (builder.state === 'pending_approval') {
          <span class="pill pill-review pill-lg"><span class="dot"></span> In review</span>
          @if (builder.onWithdraw) {
            <button class="btn btn-secondary" (click)="builder.onWithdraw!()">Withdraw</button>
          }
        } @else {
          <button class="btn btn-primary" [disabled]="!builder.canSubmit" (click)="builder.onSubmit()">
            {{ builder.submitLabel }}
          </button>
        }
      </div>
    } @else {
      <!-- Main nav -->
      <nav class="nav">
        <!-- Build/browse tabs — hidden for the approve-only role (they can do
             nothing here but approve). admins/super_admins keep them. -->
        @if (!isApproverOnly()) {
          <a routerLink="/create" routerLinkActive="nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="nav__link">
            <wg-icon name="sparkle" [size]="15" />
            Create
          </a>
          <a routerLink="/agents" routerLinkActive="nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="nav__link">
            <wg-icon name="grid" [size]="15" />
            My Agents
          </a>
          <a routerLink="/agents/directory" routerLinkActive="nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="nav__link">
            <wg-icon name="users" [size]="15" />
            Directory
          </a>
          <a routerLink="/abilities" routerLinkActive="nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="nav__link">
            <wg-icon name="bolt" [size]="15" />
            Abilities
          </a>
        }
        @if (canApprove()) {
          <a routerLink="/agents/approvals" routerLinkActive="nav__link--active" class="nav__link">
            <wg-icon name="check-circle" [size]="15" />
            Approvals
            @if (pendingApprovalsCount() > 0) {
              <span class="nav__badge">{{ pendingApprovalsCount() }}</span>
            }
          </a>
        }
      </nav>

      <div class="topbar__spacer"></div>
    }

    <!-- Right side -->
    <div class="topbar__right">
      <button type="button" class="studio-help-fab" (click)="openHelpPortal()"
        title="Open Help ↗" aria-label="Open Help">
        <wg-icon name="help-circle" [size]="18" />
      </button>
      <button type="button" class="btn btn-ghost btn-sm topbar__feedback" (click)="openFeedback()"
        title="Send feedback to the Studio team">
        <wg-icon name="chat" [size]="15" /> Feedback
      </button>
      <button class="btn btn-ghost btn-sm btn-icon" (click)="theme.toggle()" title="Toggle theme">
        <wg-icon [name]="theme.theme() === 'dark' ? 'sun' : 'moon'" [size]="16" />
      </button>
      @if (userName(); as u) {
        <div class="user-menu">
          <button
            type="button"
            class="avatar avatar--btn"
            [class.avatar--active]="usageMenuOpen()"
            [title]="u + (currentRole() ? ' · ' + currentRole() : '')"
            [attr.aria-haspopup]="true"
            [attr.aria-expanded]="usageMenuOpen()"
            (click)="toggleUsageMenu()"
          >{{ initials() }}</button>
          @if (usageMenuOpen()) {
            <div class="user-menu__dropdown" role="menu">
              <div class="user-menu__id">
                <div class="user-menu__name">{{ u }}</div>
                @if (currentRole()) {
                  <div class="user-menu__role">{{ currentRole() }}</div>
                }
              </div>
              <app-usage-meter />
            </div>
          }
        </div>
      }
      <button class="btn btn-ghost btn-sm btn-icon" (click)="onLogout()" title="Log out">
        <wg-icon name="external" [size]="15" style="transform: rotate(90deg)" />
      </button>
    </div>
  </header>

  <main class="shell__body">
    <router-outlet />
  </main>

  @if (mockMode()) {
    <app-dev-panel />
  }

  @if (feedbackOpen()) {
    <app-send-feedback-dialog
      [agentId]="shellContext.builder()?.draftId || null"
      [agentName]="shellContext.builder()?.name || null"
      [conversation]="feedbackConversation()"
      (close)="closeFeedback()" />
  }

  <wg-toasts />
  <wg-confirm-dialog />

</div>
